// JSON Schema basic types

export const STRING = 'string';

export const INTEGER = 'integer';

export const NUMBER = 'number';

export const OBJECT = 'object';

export const ARRAY = 'array';

export const BOOLEAN = 'boolean';

export const NULL = 'null';

export const COMPONENT = 'component';
